import OpenableTitle from './OpenableTitle';
import { BottomDataWrapper, GroupItemDataWrapper, VerticalDivider } from './styles';
import ContentTypeTag from '../../components/AddContent/ContentTypeTag';
import { screenSm } from 'constants/styles/breakpoints';
import { Space, Typography } from 'antd';
import { camelize } from 'utils/helpers';
import { durationFromSecs } from 'utils/helpers';

import styled from 'styled-components';
import { CourseLearningArea } from '../styles';

interface ICourseItemData {
  data: any;
  onOpen?(): void;
}

const CourseDifficulty = styled(Typography.Text)`
  display: none;

  ${screenSm} {
    display: initial;

    text-transform: capitalize;
    font-weight: 450;
    font-size: 12px;
    line-height: 14px;
    color: #57575c;
  }
`;

const CourseItemData = ({ data, onOpen }: ICourseItemData): JSX.Element => {
  const {
    content_type,
    difficulty,
    name,
    duration_in_seconds,
    main_learning_area,
    learning_areas,
    instructors,
    has_skill_check_labs,
  } = data;
  const learningAreaName = main_learning_area || learning_areas?.[0];
  const instructorName = instructors?.[0]?.name || '';

  const duration = durationFromSecs(duration_in_seconds);

  return (
    <GroupItemDataWrapper>
      <Space>
        <ContentTypeTag value={content_type} has_skill_check_labs={has_skill_check_labs} />
        <CourseDifficulty>{difficulty}</CourseDifficulty>
      </Space>
      <OpenableTitle onOpen={onOpen}>{name}</OpenableTitle>
      <BottomDataWrapper>
        {learningAreaName && (
          <CourseLearningArea value={learningAreaName}>{learningAreaName}</CourseLearningArea>
        )}
        {instructorName && (
          <>
            {learningAreaName && <VerticalDivider />}
            {instructorName}
          </>
        )}
        {duration && (
          <>
            {(learningAreaName || instructorName) && <VerticalDivider />}
            {duration}
          </>
        )}
      </BottomDataWrapper>
    </GroupItemDataWrapper>
  );
};

export default CourseItemData;
